import { PERMISSIONS_USER_PERMISSIONS } from '@dap/memberadmin/config';
import { InformationModelType, UserPermission, UserPermissionDTO } from '@dap/memberadmin/types';
import { brandadminApi } from './brandadminApi';
import { PermissionsTags } from './tags';

const tags = [...Object.values(PermissionsTags)];

export const permissionsApi = brandadminApi
  .enhanceEndpoints({ addTagTypes: tags })
  .injectEndpoints({
    endpoints: (build) => ({
      getUserPermissions: build.query<UserPermission, { brandKey: string }>({
        query: ({ brandKey }) => PERMISSIONS_USER_PERMISSIONS(brandKey),
        transformResponse: (response: UserPermissionDTO) =>
          response
            ? { brands: response.permissions, dataowners: response.dataowners ?? [] }
            : { brands: [], dataowners: [] },
        providesTags: (_result, _error, arg) => [
          {
            type: PermissionsTags.PERMISSIONS,
            id: `${InformationModelType.Brand}-${arg.brandKey}`,
          },
        ],
      }),
    }),
  });

export const { useGetUserPermissionsQuery } = permissionsApi;
